/* eslint-disable no-undef */
const $ = jQuery;
const commonInit = (function () {
  return {
    /**
     * The initialization entry.
     * @method initialize
     */
    initialize: function () {
      // this.feedPopup();
      this.addFeaturedProd();
      this.tabToggle();
      this.anchorScroll();
      this.clickMenu();
      this.pageSharing();
      this.milkInfo();
      this.initHumanMilkTips();
      this.initSectionHeaderHeight();
      this.initBackToTopOffset();
      this.initHomeCardQr();
    },
    /**
     * @method addFeaturedProd
     */
    addFeaturedProd: function () {
      $('.featured-product').closest('.views-row').addClass('featured-product-item');
    },
    /**
     * @method feedPopup
     */
    feedPopup: function () {
      $('.fedd-close, #block-feedingadvicetips .read-more').on('click', function () {
        let now = new Date();
        let expire = new Date();
        let expireDate = 0;
        expire.setDate(now.getDate() + 1);
        expire.setHours(0);
        expire.setMinutes(0);
        expire.setSeconds(0);
        expireDate = (expire.getTime() - now.getTime()) / 1000 / 60 / 60 / 24;
        Cookies.set('illuma-popup', 1, { expires: expireDate });
        $('#block-feedingadvicetips').hide();
      });

      if (Cookies.get('illuma-popup') != 1) {
        $('#block-feedingadvicetips').show();
      }
    },
    /**
     * @method backTop
     */
    backTop: function () {
      let backToTop = $('.back-to-top');
      if (!backToTop.length) {
        return false;
      }

      let backTopDisplay = () => {
        if ($(window).scrollTop() > 1) {
          backToTop.fadeIn(300);
        } else {
          backToTop.fadeOut(300);
        }
      }
      backTopDisplay()
      $(window).scroll(function () {
        backTopDisplay()
      });

      backToTop.on('click', function () {
        $('html,body').animate({
          scrollTop: 0
        }, 700);
        return false;
      })
    },
    /**
     * @method accordionToggle
     * @param {Object} oClick Click on the obj
     * @param {Object} oDisplay Display obj
     */
    accordionToggle: function (oClick, oDisplay) {
      if ($(oClick).length && oDisplay.length) {
        $(oClick).on('click', function (e) {
          e.preventDefault();
          $(oDisplay).toggle();
          $(oClick).toggleClass('is-open');
        });
      }
    },
    /**
     * The product tab toogle
     * @method tabToggle
     */
    tabToggle: function () {
      $('.product-tab').each(function () {
        $(this).children('.tab-title').children('li').each(function (index) {
          $(this).on('click', function () {
            $(this).siblings().removeClass('tab-active');
            $(this).addClass('tab-active');
            $(this).parent().next().children('li').hide();
            $(this).parent().next().children('li').eq(index).show();
          })
        })
      })
    },
    /**
     * The anchor link scroll
     * @method anchorScroll
     */
    anchorScroll: function () {
      $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - $('.section-header').height()
        }, 'slow');
      });
    },
    /**
     * @method clickMenu
     */
    clickMenu: function () {
      $(".navbar-nav .store-search").on('click',function() {
        $('#block-illumastore').show();
        $('#block-illumastore .field--name-field-item-list ').children('.field__item').each(function() {
          if($(this).hasClass('product_purchase_link')) {
            $(this).hide()
          } else {
            $(this).show()
          }
        })
        var product_purchase_link = $('#block-illumastore .field--name-field-item-list').find('.product_purchase_link').length;
        var product_field_link = $('#block-illumastore .field--name-field-item-list ').children('.field__item').length;
        if (product_purchase_link == product_field_link) {
          $(".store-buy").hide();
        } else {
          $(".store-buy").show();
        }

        $(".store-filter-pc .form-item-product-lines-target-id input").val('');
        $(".store-filter-mb .form-item-product-lines-target-id input").val('');
      })

      $(".lineoff-store").on('click',function() {
        $('#block-illumastore').show();
        $('#block-illumastore .field--name-field-item-list').children('.field__item').each(function() {
          if(!$(this).hasClass('product_purchase_link')) {
            $(this).hide()
          } else {
            $(this).show()
          }
        })

        var product_purchase_link = $('#block-illumastore .field--name-field-item-list').find('.product_purchase_link').length;
        if (product_purchase_link == 0) {
          $(".store-buy").hide();
        } else {
          $(".store-buy").show();
        }
        const product_line = $(".product-wrapper").attr("product_line")
        console.log('product_line==', product_line)
        $(".store-filter-pc .form-item-product-lines-target-id input").val(product_line);
        $(".store-filter-mb .form-item-product-lines-target-id input").val(product_line);
      })

      $(".modal-close").on('click',function() {
        $(".store-filter-pc .js-form-type-select select").val("noSelected")
        $(".store-filter-mb .js-form-type-select select").val("noSelected")
        $(".store-filter-pc .view-content").empty();
        $(".store-filter-pc nav").empty();
        $(".store-filter-mb .view-content").empty();
        $(".store-filter-mb nav").empty();
        $(".store-filter-pc .view-empty").remove();
        $(".store-filter-mb .view-empty").remove();
        var html = '<div class="view-empty">查询无结果</div>';
        $(".store-filter-pc").append(html);
        $(".store-filter-mb").append(html);
        $('#block-illumastore').hide();
      })

      $("#block-illumastore").on('click', function(event) {
        var modal = document.getElementById('block-illumastore');
        if (event.target == modal) {
          $(".store-filter-pc .js-form-type-select select").val("noSelected")
          $(".store-filter-mb .js-form-type-select select").val("noSelected")
          $(".store-filter-pc .view-content").empty();
          $(".store-filter-pc nav").empty();
          $(".store-filter-mb .view-content").empty();
          $(".store-filter-mb nav").empty();
          $(".store-filter-pc .view-empty").remove();
          $(".store-filter-mb .view-empty").remove();
          var html = '<div class="view-empty">查询无结果</div>';
          $(".store-filter-pc").append(html);
          $(".store-filter-mb").append(html);
          $('#block-illumastore').hide();
        }
      })

      if ($(window).width() > 767.9) {

        $("#block-mainnavigation ul.menu-level-1 li.menu-item--expanded").mouseover(function() {
          $(this).find('ul.menu-level-2').show();
        })
        $("#block-mainnavigation ul.menu-level-1 li.menu-item--expanded").mouseout(function() {
            $(this).find('ul.menu-level-2').hide();
        })

      } else {
        // $("#block-mainnavigation").off('click.navMobileAccordion').on('click.navMobileAccordion', 'li.menu-item--expanded > a', function(event) {
        //   event.preventDefault()
        //   event.stopPropagation()
        //   var $a = $(this)
        //   var $li = $a.closest('li.menu-item--expanded')
        //   var $wrap = $li.find('.menu-level-wrap').first()
        //   if (!$wrap.length) {
        //     return
        //   }
        //   var $submenu = $wrap.find('> ul').first()
        //   if (!$submenu.length) {
        //     $submenu = $wrap.find('ul.menu').first()
        //   }
        //   if (!$submenu.length) {
        //     return
        //   }
        //   var $parentUl = $li.parent('ul')
        //   var subEl = $submenu[0]
        //   var wasCollapsed = subEl && window.getComputedStyle(subEl).display === 'none'

        //   $submenu.toggle()

        //   if ($parentUl.hasClass('menu-level-0')) {
        //     $li.siblings('li').find('ul').hide()
        //     $li.siblings('li').find('a').removeClass('arrow-hide')
        //     $li.siblings('li').find('a').removeClass('arrow2-hide')
        //     if (wasCollapsed) {
        //       $li.find('ul.menu-level-2').hide()
        //       $li.find('li.menu-item--expanded > a').removeClass('arrow2-hide')
        //     }
        //   } else {
        //     $li.siblings('li').each(function () {
        //       var $sWrap = $(this).find('.menu-level-wrap').first()
        //       if ($sWrap.length) {
        //         $sWrap.find('> ul').first().hide()
        //       }
        //     })
        //     $li.siblings('li').find('a').removeClass('arrow-hide')
        //     $li.siblings('li').find('a').removeClass('arrow2-hide')
        //   }

        //   if ($submenu.hasClass('menu-level-1')) {
        //     if (wasCollapsed) {
        //       $a.addClass('arrow-hide')
        //     } else {
        //       $a.removeClass('arrow-hide')
        //     }
        //   } else if ($submenu.hasClass('menu-level-2')) {
        //     if (wasCollapsed) {
        //       $a.addClass('arrow2-hide')
        //     } else {
        //       $a.removeClass('arrow2-hide')
        //     }
        //   }
        // })
      }
    },
    /**
     * @method pageSharing
     */
    pageSharing: function() {
      const $s = $('.share_area');
      // const url = this.checkUrl(location.href);
      // const title = this.toPlain(document.title);
      // const logo = this.checkImg($('.pc_logo img').attr('src'));
      const url = this.checkUrl(location.href);
      const title = encodeURIComponent(this.toPlain(document.title));
      const logo = this.checkImg($('.pc_logo img').attr('src'));
      const weibourl = `//service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${logo}`;
      if (!$s.length) return;

      // Weibo sharing
      $s.find('.sina').attr('data-href', weibourl).click(function() {
        window.open(weibourl);
      });

      // Wechat sharing
      $s.find('.wechat').hover(function() {
        $(this).addClass('h');
      }, function() {
        $(this).removeClass('h');
      });
      $('.touchevents').on('click', '.share_area .wechat', function(e) {
        $(this).addClass('h');
        $('body').addClass('wechatopen');
      }).on('click', '.wechatopen', function() {
        $('body').removeClass('wechatopen');
        $('.share_area .wechat').removeClass('h');
      });

      // Copy
      const clipBoardContent = window.location.href;
      const noClipboard = function () {
        $('.copy-error').fadeIn('slow');
        setTimeout(function(){          
          $('.copy-error').fadeOut('slow');
        }, 2000);
      }
      if (ClipboardJS.isSupported()) {
        var clipboard = new ClipboardJS('.copy', {
          text: function() {
            return clipBoardContent;
          }
        });
        
        clipboard.on('success', function (e) {          
          $('.copy-success').fadeIn('slow');
          setTimeout(function(){          
            $('.copy-success').fadeOut('slow');
          }, 2000);
        });

        clipboard.on('error', function(e) { 
          noClipboard();          
        });
      } else {   
       $s.find('.copy').click(function(event) { 
          noClipboard();
        });
      } 
    },
    /**
     * @method checkUrl
     */
    checkUrl: function(str) {
      str = str.replace(/<[^>]+>|%3C[^%3E]+%3E/g,"");
      if (!this.isURL(str)) {
        return '';
      }
      return encodeURI(str);
    },
    /**
     * @method isURL
     */
    isURL: function(str) {
      return /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/gi.test(str);
    },
    /**
     * @method Return plain text.
     */
    toPlain: function(str) {
      return str.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/>/g,'');  
    },
    /**
     * @method checkImg.
     */
    checkImg: function(src) {
      src = src.replace(/<[^>]+>|%3C[^%3E]+%3E/g,"");
      if (/('|\"|)([^\"|^\']+)('|\"|>|)\.(png|jpe?g|gif|svg)(\?.*)?$/.test(src)) {
        return encodeURI(src);
      }
      return '';
      
    },
    /**
     * @method milkInfo
     */
    milkInfo: function() {
      const $m = $('.milk_info');
      const $body = $('body');
      if (!$m.length) return;

      $('#block-milkinfo').each(function() {
        if ($(this).prev('#block-pagesharing').length) {
          $(this).prev().addBack()
            .wrapAll('<div class="milkinfo-sharing"></div>');
        }
      });

      $m.find('.table table td').eq(0).append('<span class="close"></span>');

      $m.find('.milk_info_btn').on('click', function() {
        $('body').addClass('milkinfo-open');
      });

      $m.on('click', '.close', function() {
        $('body').removeClass('milkinfo-open');
      });

      $m.find('.table').on('click', function(e) {
        if ($(e.target).hasClass('table')) $('body').removeClass('milkinfo-open');
      });
    },
    
    /**
     * 将 .section-header 的实际高度写入 CSS 变量，供 body padding-top 使用
     * @method updateSectionHeaderHeight
     */
    updateSectionHeaderHeight: function () {
      const $sectionHeader = $('.section-header');
      if (!$sectionHeader.length) {
        return;
      }

      // 移动端菜单展开时 nav 可能撑到 100vh，此时不要更新 padding
      const $nav = $('.region-sub-header > nav');
      if ($(window).width() <= 767.9 && $nav.is(':visible')) {
        return;
      }

      let height = Math.ceil($sectionHeader.outerHeight());

      if ($(window).width() > 767.9) {
        const $subNav = $('.menu-level-wrap--1:visible').first();
        if ($subNav.length) {
          height += Math.ceil($subNav.outerHeight());
        }
      }

      document.documentElement.style.setProperty(
        '--section-header-height',
        `${height}px`
      );

      $('body').css('padding-top', height + 'px');
    },

    /**
     * 绑定 resize / load，并在合适的时机量高
     * @method initSectionHeaderHeight
     */
    initSectionHeaderHeight: function () {
      const self = this;

      this.updateSectionHeaderHeight();

      let resizeTimer;
      $(window).on('resize.sectionHeader', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          self.updateSectionHeaderHeight();
        }, 100);
      });

      $(window).on('load.sectionHeader', function () {
        self.updateSectionHeaderHeight();
      });
    },

    /**
     * 顶部 / 底部母乳提示：点击关闭
     * @method initHumanMilkTips
     */
    initHumanMilkTips: function () {
      const self = this;
      const $topTip = $('.top-tip');
      const $bottomTip = $('.bottom-tip');

      if ($topTip.length) {
        $topTip.on('click', '.human-milk-close', function (e) {
          e.preventDefault();
          $topTip.hide();
          self.updateSectionHeaderHeight();
        });
      }

      if ($bottomTip.length) {
        $bottomTip.on('click', '.human-milk-close-bottom', function (e) {
          e.preventDefault();
          $bottomTip.hide();
          self.updateBackToTopOffset();
        });
      }
    },

    /**
     * 根据 footer + bottom-tip 高度，更新 back-to-top 的 bottom 偏移
     * @method updateBackToTopOffset
     */
    updateBackToTopOffset: function () {
      const $footer = $('.site-footer');
      const $bottomTip = $('.bottom-tip:visible');

      let offset = 20; // 固定间距

      if ($footer.length) {
        offset += Math.ceil($footer.outerHeight());
      }

      if ($bottomTip.length) {
        offset += Math.ceil($bottomTip.outerHeight());
      }

      document.documentElement.style.setProperty(
        '--back-to-top-offset',
        `${offset}px`
      );

      $('.back-to-top').css('bottom', offset + 'px');
    },

    /**
     * @method initBackToTopOffset
     */
    initBackToTopOffset: function () {
      const self = this;

      if (!$('.back-to-top').length) {
        return;
      }

      this.updateBackToTopOffset();

      let resizeTimer;
      $(window).on('resize.backToTopOffset', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          self.updateBackToTopOffset();
        }, 100);
      });

      $(window).on('load.backToTopOffset', function () {
        self.updateBackToTopOffset();
      });
    },

    /**
     * 首页第一张卡片：点击显示二维码遮罩，点击遮罩关闭。
     *
     * @method initHomeCardQr
     */
    initHomeCardQr: function () {
      const $firstCard = $(
        '.block-content-home_card .field--name-field-home-card-item > .field__item'
      ).first();

      if (!$firstCard.length) {
        return;
      }

      const $mask = $firstCard.find('.qr-code-mask');
      const $qrCode = $firstCard.find('.qr-code');

      if (!$mask.length || !$qrCode.length) {
        return;
      }

      const openQr = function () {
        $mask.addClass('is-visible');
        $qrCode.addClass('is-visible');
        $('body').addClass('qr-code-open');
      };

      const closeQr = function () {
        $mask.removeClass('is-visible');
        $qrCode.removeClass('is-visible');
        $('body').removeClass('qr-code-open');
      };

      const $closeBtn = $qrCode.find('.qr-code-close');

      $firstCard.on('click.homeCardQr', function (e) {
        if ($mask.hasClass('is-visible')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openQr();
      });

      $mask.on('click.homeCardQr', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeQr();
      });

      $closeBtn.on('click.homeCardQr', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeQr();
      });
    },
  };
})();

const loadingSpinner = () => {
  const loadingSpinnerHtml = `<div class="lds-spinner close"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;
  const $spinner = $(loadingSpinnerHtml);
  $spinner.appendTo('body');
  return $spinner
}

export default commonInit;

export { loadingSpinner };